'use strict';

const {noMoreThan} = require('../utils/misc');
const DrawingElement = require('../classes/DrawingElement');
const Shape = require('../classes/Shape');
const Point = require('../classes/Point');

module.exports = new DrawingElement('rotation-test', function () {
    let sideLength = (this.width - this.pad * 2);

    const shapeSelect = this.addShapeSelector(3, 12, 5);
    const center = new Point(this.width / 2, this.width / 2);

    let rotation = 0;

    const _draw = () => {
        this.wipe();
        let shape = new Shape(parseInt(shapeSelect.value, 10), new Point(this.pad, this.pad), sideLength);

        shape.scaleToFitWithin(sideLength, sideLength, true);
        shape.centerAgainst(center);

        shape.setRotation(rotation);

        //console.log(`${shape}'s center is ${shape.getCenter()}, rotation is ${rotation}`);
        const [smaller] = shape.getProportionalSubShapes(1);
        smaller.centerAgainst(center);
        shape.draw(this.ctx);
        smaller.draw(this.ctx);
    };
    const draw = noMoreThan(_draw, 100);

    const [label, input] = this.addLabeledSlider('Rotation: ', 0, 360, 0);

    input.addEventListener('input', () => {
        rotation = parseInt(input.value, 10);
        label.innerText = rotation + '°';
        draw();
    });

    shapeSelect.addEventListener('change', draw);

    _draw();
});


